<template>
  <component
    :is="as"
    :type="as === 'button' ? 'button' : undefined"
    class="h-10 w-10 rounded-full bg-white hover:bg-opacity-80 shadow-xl flex items-center justify-center border border-gray-100 transition-all duration-300 willy:rounded-none willy:border-none willy:bg-primary"
    v-bind="attrs"
  >
    <slot />
  </component>
</template>

<script setup>
import { useAttrs } from 'vue'

defineProps({
  as: {
    type: String,
    default: 'button', // default is <button>
  },
})

const attrs = useAttrs()
</script>
